import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
export default function getDeviceId() {
  var ssdkl = Cookies.get('ssdkl') || localStorage.getItem('ssdkl') || sessionStorage.getItem('ssdkl');
  var cast = sessionStorage.getItem('x-cast') || localStorage.getItem('x-cast');

  if (!ssdkl) {
    if (cast) {
      try {
        var _jwtDecode = jwtDecode(cast),
            visitorId = _jwtDecode.visitorId;

        Cookies.set('ssdkl', visitorId, {
          domain: '.s7.ru',
          expires: 3650,
          path: '/'
        });
        localStorage.setItem('ssdkl', visitorId);
        sessionStorage.setItem('ssdkl', visitorId);
        return visitorId; // eslint-disable-next-line no-empty
      } catch (e) {}
    }

    var _navigator = navigator,
        userAgent = _navigator.userAgent;
    var uuid = uuidv5(userAgent, uuidv4()).replace(/-/gi, '');
    Cookies.set('ssdkl', uuid, {
      domain: '.s7.ru',
      expires: 3650,
      path: '/'
    });
    localStorage.setItem('ssdkl', uuid);
    sessionStorage.setItem('ssdkl', uuid);
    return uuid;
  }

  return ssdkl;
}